import { FC } from 'react'
import { IconProps } from '../../../LandingPage.icons'

const Arch: FC<IconProps> = ({
  className = '',
  svgClassName = '',
  height = 95,
  width = 83,
}) => (
  <span aria-label="Arch Icon" className={className} role="img">
    <svg
      className={svgClassName}
      fill="currentColor"
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M41.0519 0C18.3905 0 6.07421e-06 18.6022 6.07421e-06 41.5338L0 86.2141C0 90.7814 3.91927 94.4447 8.69275 94.4447H72.6573C77.883 94.4447 82.1038 90.4483 82.1038 85.5004L82.1038 41.5338C82.1541 18.6022 63.7636 0 41.0519 0Z" />
    </svg>
  </span>
)

export default Arch
